const NAMESPACE = "deadlineActionRow";

const KEYS = {
    dueDateChangedMessage: "dueDateChangedMessage",
    selectANewDueDatePrompt: "selectANewDueDatePrompt",
    selectANewEndDatePrompt: "selectANewEndDatePrompt",
    changeDueDateButton: "changeDueDateButton",
    markUnsatisfiedText: "markUnsatisfiedText",
    markSatisfiedText: "markSatisfiedText",
    pauseDeadlineButtonText: "pauseDeadlineButtonText",
    resumeDeadlineButtonText: "resumeDeadlineButtonText"
};

const MESSAGES = {
    [KEYS.dueDateChangedMessage]: {
        value: "Original Due Date was {OriginalDueDate} and last changed by {LastChangedUserName}",
        comment: "Text to display to user if deadline due date was changed"
    },
    [KEYS.selectANewDueDatePrompt]: {
        value: "Select a new due date",
        comment: "Select a new due date prompt"
    },
    [KEYS.selectANewEndDatePrompt]: {
        value: "Select a new end date",
        comment: "Select a new end date prompt"
    },
    [KEYS.changeDueDateButton]: {
        value: "Change due date",
        comment: "Text for change due date button"
    },
    [KEYS.markUnsatisfiedText]: {
        value: "Mark as unsatisfied",
        comment: "Text to ask user to mark unsatisfied"
    },
    [KEYS.markSatisfiedText]: {
        value: "Mark as satisfied",
        comment: "Text to ask user to mark unsatisfied"
    },
    [KEYS.pauseDeadlineButtonText]: {
        value: "Pause",
        comment: "Text for button that pauses the deadline"
    },
    [KEYS.resumeDeadlineButtonText]: {
        value: "Resume",
        comment: "Text for button that resumes a paused deadline"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
